import type { SerializedRichText } from './types'

export const EMPTY_RICH_TEXT_VALUE: SerializedRichText = {
  serialization_method: 'plain_text',
  content: '',
}
